import React from "react";
import { Search } from "lucide-react";
import { useDateRange } from "@/lib/dateRange";
import { NotificationBell } from "@/components/layout/NotificationBell";

export function Topbar() {
  const { search, setSearch } = useDateRange();

  return (
    <header className="sticky top-0 z-10 bg-nb-bg/85 backdrop-blur-md border-b" style={{ borderColor: "var(--border-subtle)" }}>
      <div className="max-w-content mx-auto px-6 lg:px-8 py-5 flex items-center gap-4">
        <div className="relative flex-1 max-w-[460px]">
          <Search size={18} strokeWidth={1.75} className="absolute left-4 top-1/2 -translate-y-1/2 text-nb-ink2" />
          <input
            data-testid="global-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search tools, teams, people"
            className="w-full h-11 pl-11 pr-14 rounded-[10px] bg-nb-surface text-[14px] text-nb-ink placeholder:text-nb-ink2 focus:outline-none"
            style={{ border: "1px solid var(--border-control)" }}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] text-nb-ink2 rounded px-1.5 py-0.5 hidden sm:block" style={{ border: "1px solid var(--border-subtle)" }}>⌘K</span>
        </div>

        <div className="flex items-center gap-3 ml-auto shrink-0">
          <NotificationBell />
        </div>
      </div>
    </header>
  );
}
